import {
  CardDTO,
  ExtendedCardDTO,
  CardWithHistoryDTO,
} from "../../generated/api";

export const GET_EXTENDED_CARD_FOR_PERSON = "GET_EXTENDED_CARD_FOR_PERSON";
export const GET_CARD_WITH_HISTORY_FOR_PERSON =
  "GET_CARD_WITH_HISTORY_FOR_PERSON";
export const GET_EXTENDED_CARD = "GET_EXTENDED_CARD";
export const SET_EXTENDED_CARD_FOR_PERSON = "SET_EXTENDED_CARD_FOR_PERSON";
export const SET_CARD_WITH_HISTORY_FOR_PERSON = "SET_CARD_WITH_HISTORY";
export const SET_EXTENDED_CARD = "SET_EXTENDED_CARD";
export const RESET_CARDS = "RESET_CARDS";
export const SET_SEARCH_CARD_FORM = "SET_SEARCH_CARD_FORM";
export const REGISTER_CARD = "REGISTER_CARD";
export const REGISTER_CARD_MODAL = "REGISTER_CARD_MODAL";
export const SET_REGISTER_CARD_FORM = "SET_REGISTER_CARD_FORM";
export const CHANGE_CARD_MODAL = "CHANGE_CARD_MODAL";
export const CHANGE_CARD = "CHANGE_CARD";
export const DELETE_CARD_MODAL = "DELETE_CARD_MODAL";
export const DELETE_CARD = "DELETE_CARD";
export const ORDER_CARD = "ORDER_CARD";
export const GET_CARDS_AS_PDF = "GET_CARDS_AS_PDF";
export const SET_EXTENDED_CARDS = "SET_EXTENDED_CARDS";
export const RESET_CARD = "RESET_CARD";
export const GET_ALL_CARDS_FOR_PERSON = "GET_ALL_CARDS_FOR_PERSON";
export const GET_ALL_CARDS_FOR_ID = "GET_ALL_CARDS_FOR_ID";
export const SET_HAS_HIDDEN_TRANSACTIONS = "SET_HAS_HIDDEN_TRANSACTIONS";
export const SET_SELECTED_HISTORY_CARD = "SET_SELECTED_HISTORY_CARD";

export const resetCards = () => ({
  type: RESET_CARDS,
});

export const resetCard = () => ({
  type: RESET_CARD,
});

export const setExtendedCardForPerson = (extendedCard: ExtendedCardDTO) => ({
  type: SET_EXTENDED_CARD_FOR_PERSON,
  extendedCard,
});

export const setExtendedCards = (extendedCards: ExtendedCardDTO[]) => ({
  type: SET_EXTENDED_CARDS,
  extendedCards,
});

export const setSelectedHistoryCard = (historyCard: any) => ({
  type: SET_SELECTED_HISTORY_CARD,
  historyCard
});

export const setExtendedCard = (extendedCard: CardDTO) => ({
  type: SET_EXTENDED_CARD,
  extendedCard,
});

export const setCardWithHistory = (cardWithHistory: CardWithHistoryDTO) => ({
  type: SET_CARD_WITH_HISTORY_FOR_PERSON,
  cardWithHistory,
});

export const setSearchCardForm = (searchForm: any) => ({
  type: SET_SEARCH_CARD_FORM,
  searchForm,
});

export const setRegisterCardForm = (registrationForm: any) => ({
  type: SET_REGISTER_CARD_FORM,
  registrationForm,
});

export const setHasHiddenTransactions = (hasHiddenTransactions: boolean) => ({
  type: SET_HAS_HIDDEN_TRANSACTIONS,
  hasHiddenTransactions,
});

const initialState = {
  cardWithHistory: null,
  extendedCard: null,
  hasHiddenTransactions: null,
  extendedCards: null,
};

export const cardReducer = (state = initialState, action: any) => {
  const { extendedCard } = action;
  const { params } = action;
  const { registrationForm } = action;
  const { hasHiddenTransactions } = action;
  const { historyCard } = action;

  switch (action.type) {
    case SET_EXTENDED_CARD_FOR_PERSON:
      return { ...state, extendedCard };
    case SET_CARD_WITH_HISTORY_FOR_PERSON:
      const { cardWithHistory } = action;
      return { ...state, cardWithHistory };
    case SET_EXTENDED_CARD:
      return { ...state, extendedCard };
    case SET_SELECTED_HISTORY_CARD:
      return { ...state, historyCard }
    case RESET_CARDS:
      return initialState;
    case SET_SEARCH_CARD_FORM:
      return { ...state, params };
    case SET_EXTENDED_CARDS:
      const { extendedCards } = action;
      return { ...state, extendedCards };
    case SET_REGISTER_CARD_FORM:
      return { ...state, registrationForm };
    case SET_HAS_HIDDEN_TRANSACTIONS:
      return { ...state, hasHiddenTransactions };
    default:
      return state;
  }
};
